import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const KEY = "velta_active_store_id";
let storeCache = [];

export function syncStoreCache(list) {
  storeCache = Array.isArray(list) ? list : [];
}

/** Sede scelta in cassa, oppure l'unica / principale se non c'è selezione. */
export function getActiveStoreRecord() {
  const id = (() => {
    try { return localStorage.getItem(KEY) || ""; } catch { return ""; }
  })();
  if (id) {
    const hit = storeCache.find((s) => s.id === id);
    if (hit) return hit;
  }
  if (storeCache.length === 1) return storeCache[0];
  return storeCache.find((s) => s.is_main) || storeCache[0] || null;
}

const Ctx = createContext({ stores: [], storeId: "", setStoreId: () => {}, store: null, multi: false, refreshStores: () => {} });

export function StoreProvider({ children }) {
  const [stores, setStores] = useState([]);
  const [storeId, setStoreIdState] = useState(() => {
    try { return localStorage.getItem(KEY) || ""; } catch { return ""; }
  });

  useEffect(() => {
    api.get("/stores").then((r) => {
      const list = Array.isArray(r.data) ? r.data : [];
      setStores(list);
      syncStoreCache(list);
      if (storeId && !list.some((s) => s.id === storeId)) setStoreIdState("");
    }).catch(() => {
      setStores([]);
      syncStoreCache([]);
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const setStoreId = (id) => {
    const v = id || "";
    setStoreIdState(v);
    try { localStorage.setItem(KEY, v); } catch { /* ignore */ }
  };

  const store = stores.find((s) => s.id === storeId) || null;
  const multi = stores.length > 1;
  const refreshStores = () => {
    api.get("/stores").then((r) => {
      const list = Array.isArray(r.data) ? r.data : [];
      setStores(list);
      syncStoreCache(list);
      setStoreIdState((cur) => {
        if (cur && !list.some((s) => s.id === cur)) {
          try { localStorage.removeItem(KEY); } catch { /* ignore */ }
          return "";
        }
        return cur;
      });
    }).catch(() => {});
  };
  return (
    <Ctx.Provider value={{ stores, storeId, setStoreId, store, multi, refreshStores }}>
      {children}
    </Ctx.Provider>
  );
}

export const useStore = () => useContext(Ctx) || { stores: [], storeId: "", setStoreId: () => {}, store: null, multi: false, refreshStores: () => {} };

export const getActiveStoreId = () => {
  try { return localStorage.getItem(KEY) || ""; } catch { return ""; }
};

/** Aggiunge store_id ai params API se in header è scelta una sede. */
export function withActiveStore(params = {}) {
  const id = getActiveStoreId();
  if (id) return { ...params, store_id: id };
  return { ...params };
}
